const profile = {
    path: '/profile',
    component: () => import('@/views/profile/Index.vue'),
    children: [
        {
            path: '',
            name: 'MyProfile',
            component: () => import('@/views/profile/my-profile/MyProfile.vue'),
            meta: {
                title: 'profile.my_profile',
                requiresAuth: true,
            },
        },
        {
            path: 'my-tax-address',
            name: 'MyTaxAddress',
            component: () =>
                import('@/views/profile/my-tax-address/MyTaxAddress.vue'),
            meta: {
                title: 'profile.my_tax_address',
                requiresAuth: true,
            },
        },
        {
            path: 'my-account',
            name: 'MyAccount',
            component: () => import('@/views/profile/my-account/MyAccount.vue'),
            meta: {
                title: 'profile.my_account',
                requiresAuth: true,
            },
        },
        {
            path: 'my-affiliations',
            name: 'MyAffiliations',
            component: () =>
                import('@/views/profile/my-affiliations/MyAffiliations.vue'),
            meta: {
                title: 'profile.my_affiliations',
                requiresAuth: true,
            },
        },
        {
            path: 'my-affiliations/:token',
            name: 'MyAffiliationsInvitation',
            component: () =>
                import(
                    '@/views/profile/my-affiliations/MyAffiliationsInvitations.vue'
                ),
            meta: {
                title: 'profile.my_affiliations_invitation',
                requiresAuth: true,
            },
            props: (route) => ({ token: route.params.token }),
        },
        // {
        //     path: 'notifications',
        //     name: 'Notifications',
        //     component: () => import('@/views/profile/Notifications.vue'),
        //     meta: {
        //         title: 'profile.notifications',
        //         requiresAuth: true
        //     }
        // },
        {
            path: 'my-courses',
            name: 'MyCourses',
            component: () => import('@/views/profile/my-courses/MyCourses.vue'),
            meta: {
                title: 'profile.my_courses',
                requiresAuth: true,
            },
        },
        {
            path: 'our-courses',
            name: 'OurCourses',
            component: () =>
                import('@/views/profile/our-courses/OurCourses.vue'),
            meta: {
                title: 'profile.our_courses',
                requiresAuth: true,
            },
        },
        {
            path: 'orders-history',
            name: 'OrdersHistory',
            component: () =>
                import('@/views/profile/orders-history/OrdersHistory.vue'),
            meta: {
                title: 'profile.orders_history',
                requiresAuth: true,
            },
        },
        {
            path: 'orders-history/:orderId',
            name: 'SingleOrder',
            component: () =>
                import('@/views/profile/orders-history/SingleOrder.vue'),
            meta: {
                title: 'profile.orders_history',
                requiresAuth: true,
            },
            props: (route) => ({ orderId: route.params.orderId }),
        },
        {
            path: 'payment-methods',
            name: 'PaymentMethods',
            component: () => import('@/views/profile/PaymentMethods.vue'),
            meta: {
                title: 'profile.payment_methods',
                requiresAuth: true,
            },
        },
        {
            path: 'current-account',
            name: 'CurrentAccount',
            component: () => import('@/views/profile/CurrentAccount.vue'),
            meta: {
                title: 'profile.current_account',
                requiresAuth: true,
            },
        },
        {
            path: 'certificates',
            name: 'Certificates',
            component: () => import('@/views/profile/Certificates.vue'),
            meta: {
                title: 'profile.certificates',
                requiresAuth: true,
            },
        },
        {
            path: 'achievements',
            name: 'Achievements',
            component: () => import('@/views/profile/Achievements.vue'),
            meta: {
                title: 'profile.goals_and_achievments',
                requiresAuth: true,
            },
        },
        {
            path: 'employees',
            name: 'Employees',
            component: () => import('@/views/profile/Employees.vue'),
            meta: {
                title: 'profile.employees',
                requiresAuth: true,
            },
        },
        {
            path: 'organization',
            name: 'Organization',
            component: () =>
                import('@/views/profile/my-organization/MyOrganization.vue'),
            meta: {
                title: 'profile.organization',
                requiresAuth: true,
            },
        },
    ],
}

export default profile
